module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA9klEQVQ4T6WS4VECQQxGHxVgB3AVCBUgHdgBWoFYCXSAdmAHYAUcFagdUILzbnaZ3M5x3Az5uUle8n2bEXfGqKd/CkxS/g/47aotAU/ACngGHoqGM3AAvoDPnMsAGzfAbKAit3kVKMCmY2j8TpO6WA5ahMRcgFp/wqPkjyubvAC7kKuyBLfImutU1OWB8CxTT+rSRJv2PV4In8ftSoAFj6ngBKjZ0P38rjw3aSICtsBboC+DmYLcLMc7YP0FUBppLppZmqf+CjjHO4gTBFjUTAHWHYfVbNgHuHVTLYDue13jW12FwRcJvgsZesr+lhJbvzBweLvsH/ZTLmH0f6FoAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dianhua.png
// module id = abui
// module chunks = 1